import { render, staticRenderFns } from "./FormCuestionarioLegal.vue?vue&type=template&id=346a32e7&scoped=true"
import script from "./FormCuestionarioLegal.vue?vue&type=script&lang=js"
export * from "./FormCuestionarioLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a32e7",
  null
  
)

export default component.exports